<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="6">
          <v-alert :value="error" type="error">
            Error with Email or Password
          </v-alert>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  v-model="email"
                  prepend-icon="mdi-account"
                  name="email"
                  label="ID"
                  type="text"
                />
                <v-text-field
                  id="password"
                  v-model="password"
                  prepend-icon="mdi-lock"
                  name="password"
                  label="Password"
                  type="password"
                />
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click="signin"> Login </v-btn>
              <v-select
                v-if="this.storeId == '0'"
                :items="storeIds"
                label="Store Ids"
                outlined
                @change="selectStoreId"
              />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    email: "",
    password: "",
    storeIds: undefined,
    error: false,
  }),
  computed: {
    storeId() {
      return this.$store.state.admin.storeId;
    },
  },
  methods: {
    selectStoreId(value) {
      window.localStorage.setItem("selected_storeId", value);
      this.$store.dispatch("FETCH_STORE");
      this.$store.dispatch("FETCH_PRODUCTS").then(() => {
        this.$store.dispatch("FETCH_LOOKS");
      });
      if (this.$route.query.redirect != undefined) {
        this.$router.push({ path: this.$route.query.redirect });
      } else {
        this.$router.push({ name: "home" });
      }
    },
    signin() {
      const email = this.email;
      const password = this.password;
      this.$store.dispatch("SIGN_IN", { email, password }).then((res) => {
        if (res.success) {
          this.error = false;
          if (this.storeId == "0") {
            this.$store.dispatch("FETCH_STORE_IDS").then(() => {
              this.storeIds = this.$store.state.store.storeIds;
            });
          } else {
            this.$store.dispatch("FETCH_STORE").then(() => {
              require("@/socket");
            });
            this.$store.dispatch("FETCH_PRODUCTS").then(() => {
              this.$store.dispatch("FETCH_LOOKS");
            });
            this.$store
              .dispatch("FETCH_STORE_CONFIG")
              .then(() => {
                console.log("-> config is set");
              })
              .catch((err) => console.log(err));
            this.$store
              .dispatch("FETCH_ADMIN_USERS")
              .then((r) => {
                console.log("-> admin store details is set");
              })
              .catch((err) => console.log(err));
            //fetch shopify access infos
            this.$store.dispatch("setLoader", {
              showing: true,
              text: "Fetch shopify access infos",
            });
            //check analytics
            this.$store
              .dispatch("ANALYTICS_STORE")
              .then(() => {
                console.log("store with analytics");
              })
              .catch(() => console.log("store without analytics"));
            //fetch openAi config
            this.$store
              .dispatch("FETCH_LLM_CONFIG")
              .then(() => {
                console.log("store with openai feature");
              })
              .catch(() => console.log("store without openai feature"));
            this.$store
              .dispatch("FETCH_SHOPIFY_ACCESS_INFOS")
              .then(() => {
                this.$store.dispatch("setLoader", {
                  showing: false,
                });
              })
              .catch((err) => {
                console.log("store no shopify");
                this.$store.dispatch("setLoader", {
                  showing: false,
                });
              });
            if (this.$route.query.redirect != undefined) {
              this.$router.push({ path: this.$route.query.redirect });
            } else {
              this.$router.push({ name: "home" });
            }
          }
        } else {
          this.error = true;
        }
      });
    },
  },
};
</script>
